export const PANE_KEYS = {
  SELECT_SAMPLES: 'SELECT_SAMPLES',
  SELECT_EXECUTION_TYPE: 'SELECT_EXECUTION_TYPE',
  EXECUTE: 'EXECUTE',
  CONFIRM_REEXECUTE: 'CONFIRM_REEXECUTE',
};

export enum PaneKey {
  SELECT_SAMPLES = 'SELECT_SAMPLES',
  SELECT_EXECUTION_TYPE = 'SELECT_EXECUTION_TYPE',
  EXECUTE = 'EXECUTE',
  CONFIRM_REEXECUTE = 'CONFIRM_REEXECUTE',
}

export const PANE_ORDER = [
  PaneKey.SELECT_SAMPLES,
  PaneKey.CONFIRM_REEXECUTE,
  PaneKey.SELECT_EXECUTION_TYPE,
  PaneKey.EXECUTE,
];

export const EXECUTION_TYPES = {
  ENTRY: 'ENTRY', // New entry
  ENTRY_TEMPLATE: 'ENTRY_TEMPLATE', // New entry from template
  EXISTING_ENTRY: 'EXISTING_ENTRY', // Existing entry
  WORKFLOW: 'WORKFLOW', // New workflow
};

export enum ExecutionType {
  ENTRY = 'ENTRY', // New entry
  ENTRY_TEMPLATE = 'ENTRY_TEMPLATE', // New entry from template
  EXISTING_ENTRY = 'EXISTING_ENTRY', // Existing entry
  WORKFLOW = 'WORKFLOW', // New workflow
}
